// sidebarStore.js

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Create a Zustand store for sidebar state
export const useSidebarStore = create(
  persist(
    (set) => ({
      menuOpen: false, // Initial state for the sidebar menu
      setMenuOpen: (menuOpen) => set({ menuOpen }), // Function to toggle menu state
    }),
    { name: 'sidebar-store' } // LocalStorage key for persistence
  )
);
